export const locations = [
  "ZENTRALE MÜNCHEN",
  "ZENTRALE AUGSBURG",
  "AICHACH",
  "AINDLING",
  "ALTENBURG",
  "ALTOMÜNSTER",
  "ALXING",
  "AUGSBURG KUKA-GRUPPE",
  "AUGSBURG-FIRNHABERAU",
  "AUGSBURG-GÖGGINGEN",
  "AUGSBURG-PFERSEE",
  "AUGSBURG-STADTBERGEN",
  "BAAR / THIERHAUPTEN",
  "BLAUBEUREN",
  "CH-KRIENS",
  "CH-LUZERN",
  "CH-ROTKREUZ",
  "CH-ZUG",
  "DACHAU",
  "DIEDORF",
  "EBERSBERG",
  "EHINGEN",
  "EURASBURG",
  "FRIEDBERG",
  "GABLINGEN",
  "GAUTING",
  "GERSTHOFEN",
  "GLONN",
  "GRAFING",
  "HOCHSCHULE-AUGSBURG",
  "KRAILLING",
  "KÖNIGSBRUNN",
  "LANDSBERG AM LECH",
  "LANDSHUT",
  "LECHFELD",
  "MEITINGEN",
  "MERING",
  "MÜHLHAUSEN",
  "MÜNCHEN-OST",
  "MÜNCHEN-SÜD",
  "MÜNCHEN-WEST",
  "NEUSÄSS-WESTHEIM",
  "OBERGRIESBACH",
  "ODELZHAUSEN",
  "REHLING",
  "REICHENBACH",
  "SCHONGAU",
  "ST. WOLFGANG",
  "STÄTZLING",
  "UNTERHACHING",
  "WELDEN",
  "WERTINGEN",
];
export const beltGrades = [
  "10. Kup",
  "9. Kup",
  "8. Kup",
  "7. Kup",
  "6. Kup",
  "5. Kup",
  "4. Kup",
  "3. Kup",
  "2. Kup",
  "1. Kup",
  "Poom",
  "1. Dan",
  "2. Dan",
  "3. Dan",
  "4. Dan",
  "5. Dan",
  "6. Dan",
];
